import moment from 'moment';
import React, { type FC } from 'react';

import type { RealtimeMessages } from '@/types/database/realtimeMessages';

import ImageElement from '../../../UI/ImageElement';
import styles from './index.module.scss';

export type MessageProps = {
  id: string;
  type: 'send' | 'receive';
  createdAt: number;
  name: string;
  content: RealtimeMessages[number]['content'];
};

const Message: FC<MessageProps> = ({ type, createdAt, name, content }) => {
  let contentElement: React.ReactNode = null;

  switch (content.type) {
    case 'text':
      contentElement = <p className={styles.contentText}>{content.text}</p>;
      break;
    case 'image':
      contentElement = <ImageElement image={content.image} />;
      break;
    default:
      break;
  }

  return (
    <div
      className={styles.message}
      style={{
        alignItems: type === 'send' ? 'flex-end' : 'flex-start',
      }}
    >
      <p className={styles.sender}>{name}</p>
      <div className={styles.content}>{contentElement}</div>
      <p className={styles.createdAt}>{moment(createdAt).format('M/D h:mm')}</p>
    </div>
  );
};

export default Message;
